import { getTemplateNavHeaderStyles } from '../NavHeaderContextual/NavHeaderContextual.styles'

const t = document.createElement('template')
t.innerHTML = `
 <wa-button
    size="small"
    appearance="plain"
    variant="neutral"
    aria-haspopup="menu"
    aria-expanded="false"
    aria-controls="contextual-dropdown-menu"
    aria-label="Contextual navigation menu"
    class="contextual-link-btn"
    with-caret><slot name="buttonText"></slot></wa-button
  >
  <nav id="contextual-dropdown-menu" class="contextual-dropdown-menu closed">
    <slot></slot>
  </nav>
`

class NavHeaderContextaulMenu extends HTMLElement {
  private handleOutsideClick: (event: MouseEvent) => void

  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))

    // Bind the handler so it can be removed later
    this.handleOutsideClick = this._handleOutsideClick.bind(this)
  }

  connectedCallback() {
    console.log('NavHeaderContextaulMenu connectedCallback', this)

    const shadow = this.shadowRoot
    if (shadow) {
      const btn = shadow.querySelector('wa-button')
      if (btn) {
        btn.addEventListener('click', () => {
          this.toggleMenu()
        })
      }
    }
  }

  disconnectedCallback() {
    document.removeEventListener('mousedown', this.handleOutsideClick)
  }

  private _handleOutsideClick(event: MouseEvent) {
    if (!this.contains(event.target as Node)) {
      this.closeMenu()
    }
  }

  private toggleMenu() {
    const panel = this.shadowRoot?.querySelector('nav')
    const button = this.shadowRoot?.querySelector('wa-button')

    if (panel && button) {
      panel.classList.toggle('closed')
      button.classList.toggle('menu-active')

      if (!panel.classList.contains('closed')) {
        document.addEventListener('mousedown', this.handleOutsideClick)
      } else {
        document.removeEventListener('mousedown', this.handleOutsideClick)
      }
    }
  }

  private closeMenu() {
    const panel = this.shadowRoot?.querySelector('nav')
    const button = this.shadowRoot?.querySelector('wa-button')

    if (panel && !panel.classList.contains('closed')) {
      panel.classList.toggle('closed')
      button?.classList.remove('menu-active')
    }
  }
}

if (!customElements.get('ts-navheader-contextual-menu')) {
  customElements.define('ts-navheader-contextual-menu', NavHeaderContextaulMenu)
}
export { NavHeaderContextaulMenu }
